import * as tslib_1 from "tslib";
import { Tools } from "@babylonjs/core/Misc/tools";
import { Matrix, Tmp, Vector3 } from "@babylonjs/core/Maths/math";
import { Container3D } from "./container3D";
/**
 * Class used to create a stack panel in 3D on XY plane
 */

var StackPanel3D =
/** @class */
function (_super) {
  tslib_1.__extends(StackPanel3D, _super);
  /**
   * Creates new StackPanel
   * @param isVertical
   */


  function StackPanel3D(isVertical) {
    if (isVertical === void 0) {
      isVertical = false;
    }

    var _this = _super.call(this) || this;

    _this._isVertical = false;
    /**
     * Gets or sets the distance between elements
     */

    _this.margin = 0.1;
    _this._isVertical = isVertical;
    return _this;
  }

  Object.defineProperty(StackPanel3D.prototype, "isVertical", {
    /**
     * Gets or sets a boolean indicating if the stack panel is vertical or horizontal (horizontal by default)
     */
    get: function get() {
      return this._isVertical;
    },
    set: function set(value) {
      var _this = this;

      if (this._isVertical === value) {
        return;
      }

      this._isVertical = value;
      Tools.SetImmediate(function () {
        _this._arrangeChildren();
      });
    },
    enumerable: true,
    configurable: true
  });

  StackPanel3D.prototype._arrangeChildren = function () {
    var width = 0;
    var height = 0;
    var controlCount = 0;
    var extendSizes = [];
    var currentInverseWorld = Matrix.Invert(this.node.computeWorldMatrix(true)); // Measure

    for (var _i = 0, _a = this._children; _i < _a.length; _i++) {
      var child = _a[_i];

      if (!child.mesh) {
        continue;
      }

      controlCount++;
      child.mesh.computeWorldMatrix(true);
      child.mesh.getWorldMatrix().multiplyToRef(currentInverseWorld, Tmp.Matrix[0]);
      var boundingBox = child.mesh.getBoundingInfo().boundingBox;
      var extendSize = Vector3.TransformNormal(boundingBox.extendSize, Tmp.Matrix[0]);
      extendSizes.push(extendSize);

      if (this._isVertical) {
        height += extendSize.y;
      } else {
        width += extendSize.x;
      }
    }

    if (this._isVertical) {
      height += (controlCount - 1) * this.margin / 2;
    } else {
      width += (controlCount - 1) * this.margin / 2;
    } // Arrange


    var offset;

    if (this._isVertical) {
      offset = -height;
    } else {
      offset = -width;
    }

    var index = 0;

    for (var _b = 0, _c = this._children; _b < _c.length; _b++) {
      var child = _c[_b];

      if (!child.mesh) {
        continue;
      }

      controlCount--;
      var extendSize = extendSizes[index++];

      if (this._isVertical) {
        child.position.y = offset + extendSize.y;
        child.position.x = 0;
        offset += extendSize.y * 2;
      } else {
        child.position.x = offset + extendSize.x;
        child.position.y = 0;
        offset += extendSize.x * 2;
      }

      offset += controlCount > 0 ? this.margin : 0;
    }
  };

  return StackPanel3D;
}(Container3D);

export { StackPanel3D };